import { createContext } from 'react';

export type ArticleListBoundaries = [number, number];

export const articleListBoundariesContext = createContext<ArticleListBoundaries>([0, 1]);
